import { supabase } from "@/lib/supabaseClient";

// Fire-and-forget on purpose: a logging failure should never block the actual
// action it's describing. Errors are swallowed with a console warning rather
// than surfaced to the user.
export async function logActivity({ actorId, clientId, action, details }) {
  const { error } = await supabase.from("activity_log").insert({
    actor_user_id: actorId,
    client_id: clientId || null,
    action,
    details: details || null,
  });
  if (error) {
    console.warn("Activity log insert failed:", error.message);
  }
}
